import LoginIndex from "./js/LoginIndex.jsx";
import LoginForm from "./js/LoginForm.jsx";

const components = [
    LoginIndex, LoginForm
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};